import axios from "axios";

var Server = axios.create({
  baseURL: "https://coinranking1.p.rapidapi.com",
  headers: {
    "Content-Type": "application/json",
    "Content-Language": "browser",
    "X-RapidAPI-Key": "8dbf08d7ebmshb6f0d1d61538ebdp1df349jsne1b32485bf82",
    "X-RapidAPI-Host": "coinranking1.p.rapidapi.com",
  },
});

var NewsServer = axios.create({
  baseURL: "https://bing-news-search1.p.rapidapi.com",
  headers: {
    "Content-Type": "application/json",
    "Content-Language": "browser",
    "X-BingApis-SDK": "true",
    "X-RapidAPI-Key": "8dbf08d7ebmshb6f0d1d61538ebdp1df349jsne1b32485bf82",
    "X-RapidAPI-Host": "bing-news-search1.p.rapidapi.com",
  },
});

export { Server, NewsServer };
